<template>
    <file-upload
            class="btn btn-primary pointer"
            :post-action="configs.uploadUrl"
            extensions="gif,jpg,jpeg,png,webp"
            accept="image/png,image/gif,image/jpeg,image/webp"
            :size="configs.size"
            :headers="configs.headers"
            v-model="avatar"
            @input-filter="inputFilter"
            @input-file="inputFile"
            ref="upload">
        <img :src="src" width="208px" height="208px" class="d-block v-avatar avatar"/>
    </file-upload>
</template>


<script>
    const VueUploadComponent = require('vue-upload-component');
    export default {
        components: {
            FileUpload: VueUploadComponent,
        },
        props: ['configs', 'src'],
        data() {
            return {
                avatar: []
            }
        },
        methods: {
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {

                    if (!/\.(jpe?g|png|gif|webp)$/i.test(newFile.name)) {
                        this.$store.dispatch('alert', {type: 2, message: this.$t('avatar.valid_format')});
                        return prevent()
                    }

                    if (newFile.size > this.configs.size) {
                        this.$store.dispatch('alert', {type: 2, message: this.$t('avatar.max_size')});
                        return prevent()
                    }
                }
            },
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        this.$emit('successUpload');
                    }
                }

                // Automatic upload
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true;
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .avatar{
        object-fit: cover !important;
    }
    
    @media (max-width: 600px) {
        img{
            width: 124px;
            height: 124px;
        }
    }
</style>